import { api } from '@/helpers/api';

export default {
  async getLessons({ commit }, { studentId, payload }) {
    const response = await api.get(`parent/me/students/${studentId}/lessons`, { params: payload });
    commit('setLessons', response.data.results);
    commit('setLesson', response.data.results.slice(-1)[0]);
  },

  clearLesson({ commit }) {
    commit('clearLesson');
  },

  clearLessons({ commit }) {
    commit('clearLessons');
  },
};
